import styles from "./StatCard.module.css";

const StatCard = ({ label, value, color, isLoading, onClick }) => {
  return (
    <div
      className={[styles.card, onClick ? styles.clickable : ""].join(" ")}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          onClick();
        }
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {isLoading ? (
        <>
          <span className={["shimmer", styles.valueShimmer].join(" ")} />
          <span className={["shimmer", styles.labelShimmer].join(" ")} />
        </>
      ) : (
        <>
          <span className={styles.value} style={{ color }}>
            {value}
          </span>
          <span className={styles.label}>{label}</span>
        </>
      )}
    </div>
  );
};

export default StatCard;
